<template>
  <div>
    <router-view />
    <div
      v-if="isDebug"
      class="p-2"
      style="position: fixed; top:0; right: 0; z-index: 2000; background-color: white; border: solid 1px;">
      <div>
        デバッグ用
      </div>
      <div>
        isIOS: {{ isIOS }}
      </div>
      <div>
        isPWA: {{ isPWA }}
      </div>
    </div>
    <!-- <div style="position: fixed; top: 0; left: 0; z-index: -1000;">
      <input
        ref="resetInput"
        class="reset-input"
        type="text"
        @focus="onFocus"
        @blur="onBlur">
    </div> -->
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import { format } from 'date-fns'
import { maintenanceAxios } from '@/plugins/axios.js'
import { isIOS, isPWA } from '@/helper/device'

export default {
  data() {
    return {
      intervalId: null,
      isIOS,
      isPWA,
    }
  },
  computed: {
    ...mapState('maintenance', ['maintenanceInfo']),
    ...mapGetters('maintenance', ['needPeriodicCheck']),
    ...mapState(['isDebug']), 
  },
  watch: {
    maintenanceInfo: {
      handler: function (val, oldVal) {
        // この置き換えをしないとvueインスタンスのメソッドが呼ばれない
        const vm = this
        const currentPath = this.$route.path
        // 今現在の値がnullの場合は何もしない
        if (!val) {
          console.log('val', val)
          console.log('valが空の場合は何もしない')
          return
        }
        // valは存在
        if (!oldVal) {
          // もしisInMaintenanceがtrueだったらメンテ画面へ
          if (val.isInMaintenance) {
            console.log('-----メンテナンスへ')
            console.log('oldVal', oldVal, 'val.isInMaintenance', val.isInMaintenance)
            console.log('前の値がnullで、今isInMaintenance:trueの場合は、メンテナンスへ遷移')
            vm.$router.push('/maintenance', () => {})
            return
          }
          // isInMaintenanceはfalse
          if (currentPath === '/maintenance') {
            console.log('-----トップへ')
            console.log('oldVal', oldVal, 'val.isInMaintenance', val.isInMaintenance, 'currentPath', currentPath)
            console.log('前の値がnullで、今isInMaintenance:falseで、メンテナンス画面にいる場合、トップへ遷移')
            vm.$router.push('/', () => {})
            return
            // 現在いる画面が通常の画面だったら何もしない
          } else {
            console.log('oldVal', oldVal, 'val.isInMaintenance', val.isInMaintenance, 'currentPath', currentPath)
            console.log('前の値がnullで、今isInMaintenance:falseで、メンテナンス以外の画面にいる場合、なにもしない')
            // location.reload(true)
            return
          }
        }
        // ここからはoldVal, valも存在

        // isInMaintenanceがfalseからtrueに
        if (!oldVal.isInMaintenance && val.isInMaintenance) {
          console.log('-----メンテナンス開始. メンテナンスへ')
          console.log('oldVal.isInMaintenance', oldVal.isInMaintenance, 'val.isInMaintenance', val.isInMaintenance)
          vm.$router.push('/maintenance', () => {})
          return
        }
        // isInMaintenanceがtrueからfalseに
        if (oldVal.isInMaintenance && !val.isInMaintenance) {
          console.log('-----メンテナンス終了. トップへ')
          console.log('oldVal.isInMaintenance', oldVal.isInMaintenance, 'val.isInMaintenance', val.isInMaintenance)
          vm.$router.push('/', () => {})
          return
        }
        // `needPeriodicCheck`がtrueからfalseに変わったらメンテ情報の取得を止める
        if (oldVal.needPeriodicCheck && !val.needPeriodicCheck) {
          console.log('----定期チェック終了', 'info', val)
          console.log('oldVal.needPeriodicCheck', oldVal.needPeriodicCheck, 'val.needPeriodicCheck', val.needPeriodicCheck)
          vm.clearInterval()
        }
      },
      deep: true
    },
  },
  async created() {
    console.log('----App created')
    await this.fetchMaintenanceInfo()
    // S3の定期チェックが必要ならinterval開始
    if (this.needPeriodicCheck) {
      this.setInterval()
    }
  },
  // mounted() {
  //   if (!this.isIOS || !this.isPWA) return
  //   // 以下の処理はiosのPWAでのみ実行
  //   // iOSのPWAでデバイスの回転後にスワイプしたりすると、position:fixedで固定されているはずのfooterの位置がおかしくなる現象が発生する
  //   // それの対策として、デバイスの回転後はじめてtouchstartが発火すると一定期間の間、フッター位置を補正する処理を走らせている
  //   const vm = this
  //   window.addEventListener('orientationchange', function() {
  //     const orientationChangedAt = Date.now()
  //     console.log('----orientation change', orientationChangedAt)
  //     let isFirstTouchstartAfterOrientation = true
  //     const touchstartHandler = () => {
  //       console.log('touchstart', orientationChangedAt)
  //       console.log('isFirstTouchstartAfterOrientation', isFirstTouchstartAfterOrientation, orientationChangedAt)
  //       // orientationchangeが呼ばれてから最初のtouchstartでは、自身のメソッドの登録を一定時間後に解除する処理をいれる
  //       if (isFirstTouchstartAfterOrientation) {
  //         isFirstTouchstartAfterOrientation = false
  //         console.log('isFirstTouchstart in firstcall', isFirstTouchstartAfterOrientation, orientationChangedAt)
  //         window.setTimeout(() => {
  //           document.removeEventListener('touchstart', touchstartHandler)
  //           console.log('回転して最初のtouchstartから5s後、touchstartHandlerを解除', orientationChangedAt)
  //         }, 5000)
  //       }
  //       vm.resetAppViewPort()
  //     }
      
  //     document.addEventListener('touchstart', touchstartHandler)
  //     console.log('touchstart registered', touchstartHandler)
  //   })
    
  // },
  methods: {
    // async resetAppViewPort() { 
    //   console.log('resetAppViewPort')
    //   this.$nextTick(async () => {
    //     await this.$refs.resetInput.focus()
    //     console.log('resetappviewport finish')
    //   })
    // },
    // onFocus() {
    //   console.log('focus')
    //   this.$refs.resetInput.blur()
    // },
    // onBlur() {
    //   console.log('blur')
    // },
    async fetchMaintenanceInfo() {
      const now = new Date()
      const timeStamp = now.getTime()
      const prettyNow = format(now, 'M月d日 HH:mm:ss')
      // キャッシュされないように、クエリにタイムスタンプを付与
      // ref: https://stackoverflow.com/questions/49263559/using-javascript-axios-fetch-can-you-disable-browser-cache
      const url = `${process.env.VUE_APP_S3_MAINTENANCE_URL}?timestamp=${timeStamp}`
      const info = await maintenanceAxios.get(url)
        .then((res) => {
          const newVal = Object.assign({}, res.data)
          newVal.now = prettyNow
          return newVal
        }).catch((err) => {
          console.warn('err', err)   
          console.warn('err.response', err.response)
          return null
        })
      this.$store.commit('maintenance/setMaintenanceInfo', info)
      console.log('got info in App', this.maintenanceInfo, prettyNow)
    },
    setInterval() {
      this.intervalId = window.setInterval(async () => {
        await this.fetchMaintenanceInfo()
      }, 5000)
      console.log('----interval start', this.intervalId)
    },
    clearInterval() {
      window.clearInterval(this.intervalId)
      console.log('----interval cleared', this.intervalId)
    }
  },
}

</script>

<style scoped lang="scss">
// .reset-input {
//   border: none; 
//   background-color: $grey02;
// }
</style>